module.exports = __webpack_public_path__ + "img/infrastructure-8.e76e119c.png";